import { EventEmitter } from "eventemitter3";
import { VersionsMetapage } from "./v0_4";
export var MetapageHashParams;
(function (MetapageHashParams) {
    MetapageHashParams["mp_debug"] = "mp_debug";
})(MetapageHashParams || (MetapageHashParams = {}));
export const isIframe = () => {
    try {
        return window !== window.top;
    }
    catch (ignored) {
        return false;
    }
};
export class MetapageShared extends EventEmitter {
    constructor() {
        super();
        this._definition = { version: VersionsMetapage.V0_3, metaframes: {} };
        this.getDefinition = this.getDefinition.bind(this);
    }
    error(err) {
        throw 'Subclass should implement';
    }
    getDefinition() {
        return this._definition;
    }
}
;
//# sourceMappingURL=Shared.js.map